import { useState } from "react";
import { apiRequest } from "../../../infrastructure/backendService";
import { CommonButton } from "../../common/StyledComponents/StyledFields";
import { ClipLoader } from "react-spinners";

const LifeTimeDonorReport = ({ sendDataToParent, getReportData }:any) => {
  const [loading, setLoading] = useState<boolean>(false);
  
    const handleLifeTimeDonationReport = async () => {
      setLoading(true);
        apiRequest({
            method: "POST",
            endpoint: '/report-dashboard/reports/treasury/LIFETIME_DONORS_REPORT/browser',
            body: JSON.stringify({}),
            includeToken:true
          })
          .then((res) => {
            setLoading(false);
            sendDataToParent(true,{reqBody:{}});
            // getReportData(res.data);
            let counter = 1;
            const response = res.data.map((report:any)=>{
              return {
                "Sr.No":counter++,
                username:report.username,
                gothram:report.gothram,
                nakshtram:report.nakshtram,
                ...report
              }
            })
            getReportData(response);
          })
          .catch((err) => {
            setLoading(false);
          })
    }
    
    return (
      <CommonButton
        sx={{ width: "fit-content", height: "38px" }}
        onClick={handleLifeTimeDonationReport}
        disabled={loading}
        id="submit"
      >
        {loading ? (
          <>
            <ClipLoader color="#fff" loading={loading} size={15} />
            <span
              style={{
                marginLeft: "8px",
                fontSize: "15px",
                textAlign: "center",
              }}
            >
              Submitting...
            </span>
          </>
        ) : (
          "Submit"
        )}
      </CommonButton>
    );
}
export default LifeTimeDonorReport;